// TODO: remove it
const excludingIds = ['33', '34', '35']

export const temporaryFilter = (posts, qualification) => posts.filter((post) => {
  if (qualification === 'partner' && excludingIds.indexOf(post.id) !== -1) {
    return false
  }

  return true
})
